import { render, staticRenderFns } from "./projectScoringSumIndex.vue?vue&type=template&id=00935581&scoped=true&"
import script from "./projectScoringSumIndex.vue?vue&type=script&lang=js&"
export * from "./projectScoringSumIndex.vue?vue&type=script&lang=js&"
import style0 from "./projectScoringSumIndex.vue?vue&type=style&index=0&id=00935581&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00935581",
  null
  
)

export default component.exports